module.exports = __webpack_public_path__ + "static/graphql-e4b4d327c1f9ae209a9c19ac03313799.png";